export enum MenuParts {
  MAIN = "main",
  SURVEY = "survey",
  QUIZ = "quiz",
}
